import router from '../router';

// Router 4: currentRoute is a ref.
export default function currentRoute() {
  return router.currentRoute.value;
}
